export default function About() {
  return (
    <>
      <h2 className="text-xl sm:text-2xl">About This Secreto</h2>
      <p className="sm:text-base md:text-lg text-sm sm:leading-[30px] leading-[1.9em]">
        Secreto is the name of this anonymous messaging application. You can
        join me to send messages anonymously to other users.
        <br />
        <br />
        There is several reason why I created this application. I created this
        application to fulfill the qualification task for a volunteer position
        at Bersinar as a Front-End Developer. Joining the community as a
        volunteer and making contributions is also one of the things I want to
        achieve. Furthermore, this application also enhances my experience in
        the field of Front-End Development. As mentioned by Bersinar, this
        application can also add to my portfolio.
        <br />
        <br />
        Bersinar is an educational platform that provides free classes
        specifically designed for preparing for the UTBK (Joint National
        Selection for State Universities) and independent entrance exams to
        universities.
        <br />
        <br />I feel happy and challenged when I create this application. I have
        learned and implemented many things in this application. I hope you
        enjoy using this application that I have made and that it brings you
        happiness. Enjoy a happy life! :)
      </p>
    </>
  );
}
